import React from 'react';
import { useTranslation } from 'react-i18next';
import { 
  Plus, 
  QrCode, 
  Users, 
  ShoppingCart, 
  Coffee,
  Globe
} from 'lucide-react';

const QuickActions = ({ 
  onAddProduct, 
  onGenerateQR, 
  onAddBarista, 
  onViewOrders, 
  onCustomizeMenu,
  onViewAnalytics,
  onExportData,
  onImportData,
  onShopSettings,
  onViewPublicMenu
}) => {
  const { t } = useTranslation();

  const actions = [
    {
      id: 'addProduct',
      icon: Plus,
      title: t('dashboard.quickActions.addProduct'),
      description: t('dashboard.quickActions.addProductDesc'),
      color: 'bg-blue-600 hover:bg-blue-700',
      onClick: onAddProduct
    },
    {
      id: 'generateQR',
      icon: QrCode,
      title: t('dashboard.quickActions.generateQR'),
      description: t('dashboard.quickActions.generateQRDesc'),
      color: 'bg-green-600 hover:bg-green-700',
      onClick: onGenerateQR
    },
    {
      id: 'viewOrders',
      icon: ShoppingCart,
      title: t('dashboard.quickActions.viewOrders'),
      description: t('dashboard.quickActions.viewOrdersDesc'),
      color: 'bg-orange-600 hover:bg-orange-700',
      onClick: onViewOrders
    },
    {
      id: 'addBarista',
      icon: Users,
      title: t('dashboard.quickActions.addBarista'),
      description: t('dashboard.quickActions.addBaristaDesc'),
      color: 'bg-purple-600 hover:bg-purple-700',
      onClick: onAddBarista
    },
    {
      id: 'viewPublicMenu',
      icon: Globe,
      title: t('dashboard.quickActions.viewPublicMenu'),
      description: t('dashboard.quickActions.viewPublicMenuDesc'),
      color: 'bg-amber-600 hover:bg-amber-700',
      onClick: onViewPublicMenu
    }
  ];

  const handleActionClick = (action) => {
    if (action.onClick) {
      action.onClick();
    }
  };

  return (
    <div className="bg-[#1f2937] rounded-xl p-6 border border-gray-700/50">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h3 className="text-xl font-bold text-white">
            {t('dashboard.quickActions.title')}
          </h3>
          <p className="text-gray-400 text-sm">
            {t('dashboard.quickActions.subtitle')}
          </p>
        </div>
        <Coffee className="w-8 h-8 text-[#a15507]" />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4">
        {actions.map((action) => (
          <button
            key={action.id}
            onClick={() => handleActionClick(action)}
            className={`${action.color} p-4 rounded-lg text-white text-left transition-all duration-200 transform hover:scale-105 hover:shadow-lg group`}
          >
            <div className="flex items-center space-x-3">
              <div className="p-2 bg-white/20 rounded-lg group-hover:bg-white/30 transition-colors">
                <action.icon className="w-5 h-5" />
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="font-semibold text-sm mb-1 truncate">
                  {action.title}
                </h4>
                <p className="text-xs text-white/80 leading-tight">
                  {action.description}
                </p>
              </div>
            </div>
          </button>
        ))}
      </div>

      <div className="mt-6 pt-6 border-t border-gray-700">
        <div className="flex items-center justify-between">
          <div className="text-sm text-gray-400">
            {t('dashboard.quickActions.tip')}
          </div>
          <div className="flex items-center space-x-2 text-xs text-gray-500">
            <span>{t('dashboard.quickActions.lastUpdated')}:</span>
            <span>{new Date().toLocaleDateString()}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QuickActions;